import { render, staticRenderFns } from "./SysApiMockForm.vue?vue&type=template&id=50fbe300&"
import script from "./SysApiMockForm.vue?vue&type=script&lang=js&"
export * from "./SysApiMockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports